import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const tabPanelClasses = tv({
  base: [
    "Tab__Panel",
    "relative",
    "mt-3",
    "w-full",
    "-outline-offset-1",
    "outline-blue-800",
    "focus-visible:rounded-md",
    "focus-visible:outline",
    "focus-visible:outline-2",
  ],
  variants: {},
});

export type TabListVariants = VariantProps<typeof tabPanelClasses>;
